<template>
  <div class="item-detail" :class="styleTest">
    <div class="pic" :style="{backgroundImage:`url('${coursePic}')`}"></div>
    <div class="content">
      <p>{{courseName}}</p>
      <h5>
        {{coursePrice}}
      </h5>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    styleTest: {
      type: String,
      default: "primary"
    }
  },
  computed: {
    courseName() {
      return this.data.name;
    },
    coursePic() {
      return this.data.picture;
    },
    coursePrice() {
      return this.styleTest == "primary"
        ? `￥${this.data.price}| VIP免费`
        : `¥${this.data.price}| 原价:${this.data.price}`;
    }
  }
};
</script>
<style scoped>
.item-detail .pic {
  display: block;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.item-detail .content h5,
.item-detail .content p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.primary .pic {
  width: 126px;
  height: 126px;
  border-radius: 8px;
}

.item-detail.primary .content p {
  font-size: 14px;
  color: #244352;
  line-height: 20px;
  margin: 8px 0 2px;
}

.item-detail.primary .content h5 {
  font-size: 12px;
  color: #FF6886;
  line-height: 17px;
}

.item-detail.parent-course .pic {
  width: 104px;
  height: 104px;
}

.item-detail.parent-course .content {
  padding: 6px 0px;
}

.item-detail.parent-course .content p {
  width: 104px;
  height: 17px;
  font-size: 12px;
  font-weight: 500;
  color: #333333;
  line-height: 17px;
  margin-bottom: 4px;
}
.item-detail.parent-course .content h5 {
  height: 14px;
  font-size: 10px;
  font-weight: bold;
  color: #fe2c2a;
  line-height: 14px;
}
</style>


